import { useStore } from '../motionEditorStore';
import { END_EFFECTOR_COLORS, type EndEffectorName } from '../types';

export default function ConstraintPanel() {
  const store = useStore();
  const snap = store.state;

  const formatNum = (n: number) => (n >= 0 ? `+${n.toFixed(3)}` : n.toFixed(3));

  return (
    <div className="flex flex-col gap-3">
      {/* Constraints list */}
      <div className="border-primary bg-secondary rounded-lg border p-3">
        <div className="mb-2 flex items-center justify-between">
          <h3 className="text-primary text-sm font-semibold">
            Constraints ({snap.constraints.length})
          </h3>
          {snap.constraints.length > 0 && (
            <button
              onClick={() => store.clearConstraints()}
              className="text-red hover:text-red-60 text-xs"
            >
              Clear all
            </button>
          )}
        </div>

        {snap.constraints.length === 0 ? (
          <p className="text-secondary text-xs">
            Select an end-effector in the viewer and drag to add constraints.
          </p>
        ) : (
          <div className="flex max-h-48 flex-col gap-1 overflow-y-auto">
            {snap.constraints.map((c, i) => (
              <div
                key={`${c.frame}-${c.endEffector}-${i}`}
                className="group bg-primary flex items-center gap-2 rounded px-2 py-1 text-xs"
              >
                <span
                  className="inline-block h-2 w-2 rounded-full"
                  style={{
                    backgroundColor:
                      END_EFFECTOR_COLORS[c.endEffector as EndEffectorName] ||
                      '#888',
                  }}
                />
                <span className="text-secondary">F{c.frame}</span>
                <span className="text-primary font-medium">
                  {c.endEffector}
                </span>
                <span className="text-secondary font-mono">
                  ({formatNum(c.dx)}, {formatNum(c.dy)}, {formatNum(c.dz)})
                </span>
                <button
                  onClick={() => store.removeConstraint(i)}
                  className="text-secondary hover:text-red ml-auto opacity-0 transition-opacity group-hover:opacity-100"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Constraint preview string */}
      {snap.constraints.length > 0 && (
        <div className="border-primary bg-secondary rounded-lg border p-3">
          <h3 className="text-secondary mb-1 text-xs font-semibold">
            API Payload Preview
          </h3>
          <pre className="bg-primary border-primary text-primary max-h-24 overflow-y-auto rounded border p-2 font-mono text-[10px] whitespace-pre-wrap">
            {snap.constraints
              .map(
                (c) =>
                  `${c.frame} ${c.endEffector} ${c.dx.toFixed(4)} ${c.dy.toFixed(4)} ${c.dz.toFixed(4)}`,
              )
              .join('\n')}
          </pre>
        </div>
      )}
    </div>
  );
}
